import { DiscountDto } from "../../../types";

export const EXIST_DISCOUNT = "EXIST_DISCOUNT";
export const EXIST_DISCOUNT_SUCCESS = "EXIST_DISCOUNT_SUCCESS";
export const EXIST_DISCOUNT_ERROR = "EXIST_DISCOUNT_ERROR";
export const RESET_EXIST_DISCOUNT = "RESET_EXIST_DISCOUNT";

export interface ExistDiscount {
  type: typeof EXIST_DISCOUNT;
  payload: { coupon_id: number };
}

export interface ExistDiscountSuccess {
  type: typeof EXIST_DISCOUNT_SUCCESS;
  payload: DiscountDto;
}

export interface ExistDiscountError {
  type: typeof EXIST_DISCOUNT_ERROR;
  payload: string | boolean;
}

export interface ResetExistDiscount {
  type: typeof RESET_EXIST_DISCOUNT;
  payload: undefined;
}

export interface State {
  data: DiscountDto | null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions =
  | ExistDiscount
  | ExistDiscountSuccess
  | ExistDiscountError
  | ResetExistDiscount;